import React from 'react';

/**
 * Functional UI icons — inline Lucide SVGs (https://lucide.dev, ISC license).
 * Substitution per the design briefing: Foubert has no official icon set;
 * Lucide's 1.5px stroke and rounded terminals sit well next to Pulp Display.
 * Status markers use the ScoopMarker, never these. No emoji anywhere.
 */
function Icon({ children, size = 20, className = '', label }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            role={label ? 'img' : undefined}
            aria-label={label}
            aria-hidden={label ? undefined : true}
        >
            {children}
        </svg>
    );
}

export const IconMenu = (p) => (
    <Icon {...p}><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/></Icon>
);

export const IconX = (p) => (
    <Icon {...p}><path d="M18 6 6 18"/><path d="m6 6 12 12"/></Icon>
);

export const IconChevronDown = (p) => (
    <Icon {...p}><path d="m6 9 6 6 6-6"/></Icon>
);

export const IconChevronRight = (p) => (
    <Icon {...p}><path d="m9 18 6-6-6-6"/></Icon>
);

export const IconBell = (p) => (
    <Icon {...p}><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></Icon>
);

export const IconBellOff = (p) => (
    <Icon {...p}><path d="M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5"/><path d="M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/><path d="m2 2 20 20"/></Icon>
);

export const IconMapPin = (p) => (
    <Icon {...p}><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/></Icon>
);

export const IconLocate = (p) => (
    <Icon {...p}><line x1="2" y1="12" x2="5" y2="12"/><line x1="19" y1="12" x2="22" y2="12"/><line x1="12" y1="2" x2="12" y2="5"/><line x1="12" y1="19" x2="12" y2="22"/><circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="2" fill="currentColor" stroke="none"/></Icon>
);

export const IconClock = (p) => (
    <Icon {...p}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></Icon>
);

export const IconCalendar = (p) => (
    <Icon {...p}><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></Icon>
);

export const IconHome = (p) => (
    <Icon {...p}><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></Icon>
);

export const IconSmartphone = (p) => (
    <Icon {...p}><rect x="5" y="2" width="14" height="20" rx="2"/><path d="M12 18h.01"/></Icon>
);

export const IconHelpCircle = (p) => (
    <Icon {...p}><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/></Icon>
);

export const IconCheck = (p) => (
    <Icon {...p}><path d="M20 6 9 17l-5-5"/></Icon>
);

export const IconZap = (p) => (
    <Icon {...p}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></Icon>
);

export const IconCreditCard = (p) => (
    <Icon {...p}><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></Icon>
);

export const IconGlobe = (p) => (
    <Icon {...p}><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></Icon>
);

export const IconArrowRight = (p) => (
    <Icon {...p}><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></Icon>
);

export const IconExternal = (p) => (
    <Icon {...p}><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></Icon>
);

export const IconTruck = (p) => (
    <Icon {...p}><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></Icon>
);

export default Icon;
